import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

const removeOpenHousesByListingRef = async ({
  listingRef,
  mlsType,
  ohUids,
}: {
  listingRef: string;
  mlsType: string;
  ohUids: string;
}) => {
  const config: AxiosRequestConfig = {
    method: 'POST',
    url: `/rets/openhouse/removeopenhouses`,
    data: { listingRef, mlsType, ohUids },
  };

  const { data: removedCount } = await axios.request<number>(config);

  return removedCount;
};

export default removeOpenHousesByListingRef;
